// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const tl: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Paano Maglaro',
  'howto.pieces.heading': 'Mga piyesa',
  'howto.pieces.source': 'Pinagmulan',
  'howto.pieces.mirror': 'Salamin',
  'howto.pieces.switch': 'Switch',
  'howto.pieces.exit': 'Labasan',
  'howto.pieces.wall': 'Pader',
  'howto.controls.heading': 'Mga kontrol',
  'howto.controls.clickSlot.line1': 'I-click ang puwang',
  'howto.controls.clickSlot.line2': 'maglagay ng salamin',
  'howto.controls.dragMirror.line1': 'I-drag ang salamin',
  'howto.controls.dragMirror.line2': 'paikutin',
  'howto.controls.rightClick.line1': 'Right-click',
  'howto.controls.rightClick.line2': 'alisin ang salamin',
  'howto.controls.hint':
    'Gulong ng mouse: pinong pag-ikot ng 1°.   Tap sa salamin: pag-ikot ng 15°.',
  'howto.objective.line1': 'Sindihan ang bawat switch — kusang bubukas ang lock ng labasan.',
  'howto.objective.line2':
    'Pagkatapos, i-click ang labasan. Lutasin sa pinakakaunting salamin na kaya mo.',

  'howtoColor.title': 'Kulay at mga Prisma',
  'howtoColor.pieces.heading': 'Bagong piyesa',
  'howtoColor.pieces.prism': 'Prisma',
  'howtoColor.pieces.redSwitch': 'Pulang switch',
  'howtoColor.pieces.yellowSwitch': 'Dilaw na switch',
  'howtoColor.pieces.whiteSwitch': 'Puting switch',
  'howtoColor.how.heading': 'Paano sila gumagana',
  'howtoColor.how.line1':
    'Ang puting sinag ay may dalang pula, berde, at asul na liwanag nang sabay-sabay.',
  'howtoColor.how.line2':
    'Hinahati ng prisma ang puting liwanag sa tatlong kulay na sinag sa tatlong gilid nito.',
  'howtoColor.how.line3':
    'I-click ang naka-lagay na prisma upang paikutin ang papasok na mukha nito.',
  'howtoColor.switches.line1':
    'Nagpapakita ang mga switch ng mga kulay na tuldok — iyon ang kulay na kailangan nila.',
  'howtoColor.switches.line2':
    'Ang dilaw na switch (pula + berdeng tuldok) ay nangangailangan ng dalawang kulay nang sabay.',
  'howtoColor.switches.line3':
    'Ang puting switch (tatlong kulay) ay nangangailangan ng pula, berde, AT asul nang sabay.',

  'options.hints.label': 'Ipakita ang anggulo ng pahiwatig sa mga palaisipan',
  'options.hints.help':
    'Ipinapakita ang anggulo sa pagitan ng papasok at sumalamin na sinag sa bawat tama.',

  'level.01-intro.title': 'Kumusta Liwanag',
  'level.02-two-mirrors.title': 'Dalawang Liko',
  'level.03-corner.title': 'May Pader sa Daan',
  'level.04-two-targets.title': 'Dalawang Target',
  'level.05-tight.title': 'Masikip',
  'level.06-hello-color.title': 'Kumusta Kulay',
  'level.07-pick-a-side.title': 'Pumili ng Panig',
  'level.08-yellow.title': 'Dilaw',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Spectrum',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'tama',
  'puzzle.hint.angleType.acute': 'matulis',
  'puzzle.hint.angleType.obtuse': 'mapurol',
  'puzzle.hint.label': '{angle}°\n{type}',
};
